import React from "react";
import styles from "./index.module.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Lexus from "img/Lexus_t.jpg";

const Ceo = () => {
    const lang = useSelector((state) => state.app.lang);
    const { t } = useTranslation();

    const members = [
        {
            name: t("Kai"),
            role: t("KaiRole"),
            img: "/bgImg/Kai.jpg",
            remarks: t("KaiRemarks"),
            linkedIn: "https://www.linkedin.com/in/iltae-lee",
        },
        {
            name: t("Jade"),
            role: t("JadeRole"),
            img: "/bgImg/Jade.jpg",
            remarks: t("JadeRemarks"),
        },
        {
            name: t("DEHan"),
            role: t("DEHanRole"),
            img: "/bgImg/DEH.png",
            remarks: t("DEHanRemarks"),
        },
        {
            name: t("Lym"),
            role: t("LymRole"),
            img: "/bgImg/Lym.jpg",
            remarks: t("LymRemarks"),
        },
    ];

    return (
        <div className={styles.ceoContainer}>
            <div>
                <div className={styles.topHeader}>{t("CeoGreetingHeader")}</div>
                <p dangerouslySetInnerHTML={{ __html: t("CeoGreetingText") }} />
            </div>
            <div>
                <div className={styles.lastHeader}>{t("BiographyHeader")}</div>
                <ul>
                    <li>{t("Bio1")}</li>
                    <li>{t("Bio2")}</li>
                    <li>{t("Bio3")}</li>
                    <li>{t("Bio4")}</li>
                </ul>
            </div>

            <div className={styles.header}>{t("Staff")}</div>
            <div className={styles.membersContainer}>
                {members.map((member, index) => (
                    <div key={index} className={styles.memberCard}>
                        <img
                            className={styles.memberImage}
                            src={member.img}
                            alt={member.name}
                        />
                        <div className={styles.memberName}>{member.name}</div>
                        <div className={styles.memberRole}>{member.role}</div>
                        {member.remarks && (
                            <>
                                <hr />
                                <div className={styles.memberRemarks}>
                                    {member.remarks}
                                </div>
                            </>
                        )}
                        {member.linkedIn && (
                            <div className={styles.memberLinkedIn}>
                                <a
                                    href={member.linkedIn}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon icon={faLinkedin} />{" "}
                                    {t("LinkedIn")}
                                </a>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {lang !== "cn" && (
                <div>
                    <div className={styles.header}>{t("Car")}</div>
                    <div className={styles.carDiv}>
                        {t("CarDesc")}
                        <img
                            src={Lexus}
                            className={styles.logoImg}
                            alt="Lexus"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Ceo;
